import {Component, Input, OnInit, TemplateRef, ViewChild, Output, EventEmitter, ViewChildren, QueryList, AfterViewInit, OnDestroy} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import feather from 'feather-icons';
import {TresorerieService} from '../../../../../services/tresorerie/tresorerie.service';
import {RemiseBanque} from '../../../../../models/Tresorerie/RemiseBanque';
import {Tresorerie} from '../../../../../models/Tresorerie/Tresorerie';
import {BanqueService} from '../../../../../services/Banque/banque.service';
import {Banque} from '../../../../../models/banque.model';
import {environment} from '../../../../../../environments/environment';
import {CompteBancaireComponent} from '../../../../parametre/compte-bancaire/compte-bancaire.component';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-remise-banque',
  templateUrl: './remise-banque.component.html',
  styleUrls: ['./remise-banque.component.scss']
})
export class RemiseBanqueComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() data: any = null;
    @Input() soldeType: string = 'secondaire';
    @Output() remiseCreated = new EventEmitter<void>();
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
    @ViewChild('compteBancaire') compteBancaireComponent!: CompteBancaireComponent;

    formData: any = {
        type_remise: '',
        numero_remise: '',
        date_banque: '',
        montant_total: 0,
        compte_bancaire_id: null,
        note: ''
    };

    stationId: number = 0;
    userId: number = 0;
    clientId: number = 0;
    file: string = '';
    isLoading = false;
    currentStep = 1;
    numberValue: number = 0;
    stepValue: number = 1;
    minValue: number = 0;
    maxValue?: number;
    disabledValueIncrement: boolean = false;
    disabledValueDecrement: boolean = false;
    soldeDisponible: number = 0;
    comptesBancaires: Banque[] = [];
    compteBancaireSelectionne: Banque | null = null;
    montantTraites: number = 0;
    montantCheques: number = 0;
    montantEspeces: number = 0;
    soldeData: any = null;
    private subscriptions = new Subscription();

    private modalRef!: NgbModalRef;

    constructor(
        private modalService: NgbModal,
        private toastr: ToastrService,
        private tresorerieService: TresorerieService,
        private banqueService: BanqueService
    ) {}

    ngOnInit(): void {
        this.loadUserData();
        this.file = environment.file_url;
    }
    private loadComptesBancaires(): void {
        if (!this.stationId) {
            console.warn('⚠️ [RemiseBanqueComponent] Station ID non défini, impossible de charger les comptes bancaires');
            return;
        }

        console.log('🔄 [RemiseBanqueComponent] Chargement des comptes bancaires:');
        console.log('   - Station ID:', this.stationId);
        console.log('   - Client ID:', this.clientId);
        
        this.banqueService.getBanques(this.stationId).subscribe({
            next: (response) => {
                let allComptes = response.banques || [];
                console.log('✅ [RemiseBanqueComponent] Tous les comptes bancaires chargés:', allComptes.length);
                if (this.clientId) {
                    allComptes = allComptes.filter(
                        compte => compte.client_id === this.clientId
                    );
                    console.log('📋 [RemiseBanqueComponent] Comptes filtrés par client_id:', allComptes.length);
                }
                this.comptesBancaires = allComptes;
                console.log('✅ [RemiseBanqueComponent] Comptes bancaires à afficher:', this.comptesBancaires.length);
            },
            error: (error) => {
                console.error('❌ [RemiseBanqueComponent] Erreur lors du chargement des comptes bancaires:', error);
                this.toastr.error('Erreur lors du chargement des comptes bancaires.', 'Erreur');
            }
        });
    }
    onCompteBancaireChange(): void {
        if (this.formData.compte_bancaire_id) {
            this.compteBancaireSelectionne = this.comptesBancaires.find(
                c => c.id === this.formData.compte_bancaire_id
            ) || null;
            console.log('📋 [RemiseBanqueComponent] Compte bancaire sélectionné:', this.compteBancaireSelectionne);
        } else {
            this.compteBancaireSelectionne = null;
        }
    }
    selectCompteBancaire(compte: Banque): void {
        this.formData.compte_bancaire_id = compte.id;
        this.compteBancaireSelectionne = compte;
        console.log('✅ [RemiseBanqueComponent] Compte bancaire sélectionné:', compte);
    }
    isCompteBancaireSelected(compteId: number): boolean {
        return this.formData.compte_bancaire_id === compteId;
    }
    onCompteBancaireCardClick(compte: Banque): void {
        this.selectCompteBancaire(compte);
    }

    ngAfterViewInit(): void {
        feather.replace();
        this.setupCompteBancaireSelection();
    }
    private refreshFeatherIcons(): void {
        setTimeout(() => {
            feather.replace();
        }, 100);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    private setupCompteBancaireSelection(): void {
        setTimeout(() => {
            if (this.compteBancaireComponent) {
                this.attachClickListeners();
            }
        }, 500);
    }
    private attachClickListeners(): void {
        const compteBancaireElement = document.querySelector('app-compte-bancaire');
        if (compteBancaireElement) {
            const cards = compteBancaireElement.querySelectorAll('.border.border-primary');
            cards.forEach((card, index) => {
                if (index < this.comptesBancaires.length) {
                    const compte = this.comptesBancaires[index];
                    card.addEventListener('click', () => {
                        this.selectCompteBancaire(compte);
                    });
                    (card as HTMLElement).style.cursor = 'pointer';
                }
            });
        }
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                this.userId = user?.id ? Number(user.id) : 0;
                this.clientId = user?.client_id ? Number(user.client_id) : (user?.id ? Number(user.id) : 0);
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : 0;
                console.log('📋 [RemiseBanqueComponent] Données utilisateur chargées:');
                console.log('   - User ID:', this.userId);
                console.log('   - Client ID:', this.clientId);
                console.log('   - Station ID:', this.stationId);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des données utilisateur:', error);
        }
    }
    private loadAllSoldes(): void {
        if (!this.stationId) {
            console.warn('⚠️ [RemiseBanqueComponent] Station ID non défini');
            this.montantTraites = 0;
            this.montantCheques = 0;
            this.montantEspeces = 0;
            return;
        }

        console.log('🔄 [RemiseBanqueComponent] Chargement des soldes (station + user si disponible):');
        console.log('   - Station ID:', this.stationId);
        console.log('   - User ID:', this.userId);
        console.log('   - Type de solde:', this.soldeType);

        const soldes$ = this.userId
            ? this.tresorerieService.getSoldesByStationAndUser(this.stationId, this.userId)
            : this.tresorerieService.getSoldesByStation(this.stationId);

        soldes$.subscribe({
            next: (soldes: any[]) => {
                const list = soldes || [];
                const solde = list.find((s: any) => s.type_solde === this.soldeType);
                
                if (!solde) {
                    console.warn('⚠️ [RemiseBanqueComponent] Aucun solde trouvé pour type_solde =', this.soldeType);
                    this.montantTraites = 0;
                    this.montantCheques = 0;
                    this.montantEspeces = 0;
                    this.soldeData = null;
                    return;
                }

                this.soldeData = solde;
                const parseMontant = (value: any): number => {
                    if (value === null || value === undefined || value === '') return 0;
                    if (typeof value === 'number') return isNaN(value) ? 0 : value;
                    if (typeof value === 'string') {
                        const cleaned = value.toString().replace(/[^\d.,-]/g, '').replace(',', '.');
                        const parsed = parseFloat(cleaned);
                        return isNaN(parsed) ? 0 : parsed;
                    }
                    return 0;
                };
                this.montantTraites = parseMontant((solde as any).montant_traites ?? solde.montant_traite ?? 0);
                this.montantCheques = parseMontant((solde as any).montant_cheques ?? solde.montant_cheque ?? 0);
                this.montantEspeces = parseMontant(solde.montant_espece ?? 0);

                console.log('💰 [RemiseBanqueComponent] Montants chargés:');
                console.log('   - Traites:', this.montantTraites);
                console.log('   - Chèques:', this.montantCheques);
                console.log('   - Espèces:', this.montantEspeces);
                this.updateSoldeDisponibleSelonType();
            },
            error: (error) => {
                console.error('❌ [RemiseBanqueComponent] Erreur lors du chargement:', error);
                this.montantTraites = 0;
                this.montantCheques = 0;
                this.montantEspeces = 0;
                this.soldeData = null;
            }
        });
    }

    private updateSoldeDisponibleSelonType(): void {
        if (!this.formData.type_remise) {
            this.soldeDisponible = 0;
            this.maxValue = 0;
            this.updateDisabledStates();
            return;
        }

        switch (this.formData.type_remise) {
            case 'cheque':
                this.soldeDisponible = this.montantCheques;
                break;
            case 'traite':
                this.soldeDisponible = this.montantTraites;
                break;
            case 'espece':
                this.soldeDisponible = this.montantEspeces;
                break;
            default:
                this.soldeDisponible = 0;
        }

        this.maxValue = this.soldeDisponible;
        this.updateDisabledStates();
    }

    private loadSoldeDisponible(): void {
        if (this.soldeData) {
            this.updateSoldeDisponibleSelonType();
            return;
        }
        this.loadAllSoldes();
    }

    increment(): void {
        if (this.maxValue !== undefined && this.numberValue >= this.maxValue) {
            return;
        }
        this.numberValue += this.stepValue ?? 1;
        this.formData.montant_total = this.numberValue;
        this.updateDisabledStates();
    }

    decrement(): void {
        if (this.numberValue <= this.minValue) {
            return;
        }
        this.numberValue -= this.stepValue ?? 1;
        this.formData.montant_total = this.numberValue;
        this.updateDisabledStates();
    }

    openModal() {
        this.resetForm();
        if (this.stationId) {
            this.loadComptesBancaires();
            this.loadAllSoldes();
        }
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
            windowClass: 'custom-modal'
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }

    private resetForm() {
        this.currentStep = 1;
        this.numberValue = 0;
        this.compteBancaireSelectionne = null;
        this.soldeData = null;
        this.montantTraites = 0;
        this.montantCheques = 0;
        this.montantEspeces = 0;
        this.formData = {
            type_remise: '',
            numero_remise: '',
            date_banque: new Date().toISOString().split('T')[0],
            montant_total: 0,
            compte_bancaire_id: null,
            note: ''
        };
    }

    nextStep() {
        if (this.currentStep === 1) {
            if (!this.formData.montant_total || this.formData.montant_total <= 0) {
                this.toastr.error('Le montant est requis et doit être supérieur à 0.', 'Erreur');
                return;
            }
            if (!this.formData.type_remise) {
                this.toastr.error('Veuillez sélectionner un type de remise.', 'Erreur');
                return;
            }
        }
        if (this.currentStep === 2) {
            if (!this.formData.numero_remise) {
                this.toastr.error('Le numéro de remise est requis.', 'Erreur');
                return;
            }
            if (!this.formData.date_banque) {
                this.toastr.error('La date de banque est requise.', 'Erreur');
                return;
            }
            if (!this.formData.compte_bancaire_id) {
                this.toastr.error('Le compte bancaire est requis.', 'Erreur');
                return;
            }
        }
        if (this.currentStep < 4) {
            this.currentStep++;
            if (this.currentStep === 3 && this.formData.type_remise) {
                console.log('🔄 [RemiseBanqueComponent] Arrivée à l\'étape 3, rechargement du solde disponible');
                this.loadSoldeDisponible();
            }
        }
    }

    prevStep() {
        if (this.currentStep > 1) this.currentStep--;
    }
    goToStep(step: number): void {
        if (step <= this.currentStep || (step === this.currentStep + 1 && this.canGoToStep(step))) {
            this.currentStep = step;
            if (step === 3 && this.formData.type_remise) {
                console.log('🔄 [RemiseBanqueComponent] Navigation vers l\'étape 3, rechargement du solde disponible');
                this.loadSoldeDisponible();
            }
        }
    }
    private canGoToStep(step: number): boolean {
        switch (step) {
            case 2:
                return !!(this.formData.type_remise && this.formData.montant_total > 0);
            case 3:
                return !!(this.formData.type_remise && this.formData.montant_total > 0 && 
                          this.formData.numero_remise && this.formData.date_banque && this.formData.compte_bancaire_id);
            case 4:
                return !!(this.formData.type_remise && this.formData.montant_total > 0 && 
                          this.formData.numero_remise && this.formData.date_banque && this.formData.compte_bancaire_id);
            default:
                return true;
        }
    }

    resetStepper() {
        this.currentStep = 1;
    }
    onTypeRemiseChange(): void {
        console.log('🔄 [RemiseBanqueComponent] Type de remise changé:', this.formData.type_remise);
        this.updateSoldeDisponibleSelonType();
        if (this.maxValue !== undefined && this.numberValue > this.maxValue) {
            this.numberValue = this.maxValue;
            this.formData.montant_total = this.maxValue;
        }
        this.updateDisabledStates();
        this.refreshFeatherIcons();
    }

    private updateDisabledStates(): void {
        this.disabledValueDecrement = this.numberValue <= this.minValue;

        if (this.maxValue !== undefined) {
            this.disabledValueIncrement = this.numberValue >= this.maxValue;
        } else {
            this.disabledValueIncrement = false;
        }
    }

    validateRemise() {
        if (!this.validateForm()) {
            return;
        }

        this.isLoading = true;
        const banqueId = this.compteBancaireSelectionne?.id || null;
        
        if (!banqueId) {
            this.toastr.error('Le compte bancaire est requis pour créer la remise.', 'Erreur');
            this.isLoading = false;
            return;
        }
        
        const remise: RemiseBanque = {
            numero_remise: this.formData.numero_remise,
            date_banque: this.formData.date_banque,
            type_remise: this.formData.type_remise,
            montant_total: this.formData.montant_total.toString(),
            station_id: this.stationId,
            user_id: this.userId,
            banque_id: banqueId,
            compte_bancaire_id: this.formData.compte_bancaire_id,
            solde_type: this.soldeType,
            note: this.formData.note || null,
            statut: 'en_attente'
        };

        this.tresorerieService.createRemiseBanque(remise).subscribe({
            next: (result) => {
                let remiseId: number | null = null;
                const resultAny = result as any;
                if (resultAny?.data?.remise_banque?.id) {
                    remiseId = resultAny.data.remise_banque.id;
                } else if (resultAny?.id) {
                    remiseId = resultAny.id;
                } else if (resultAny?.data?.id) {
                    remiseId = resultAny.data.id;
                } else if (resultAny?.data?.remise?.id) {
                    remiseId = resultAny.data.remise.id;
                } else if (resultAny?.remise?.id) {
                    remiseId = resultAny.remise.id;
                } else if (resultAny?.data && typeof resultAny.data === 'object' && resultAny.data.id) {
                    remiseId = resultAny.data.id;
                } else if (Array.isArray(resultAny?.data) && resultAny.data.length > 0 && resultAny.data[0]?.id) {
                    remiseId = resultAny.data[0].id;
                }
                if (!remiseId) {
                    console.warn('⚠️ [RemiseBanqueComponent] ID non trouvé dans les chemins standards, recherche approfondie...');
                    if (resultAny && typeof resultAny === 'object' && 'id' in resultAny && resultAny.id !== undefined) {
                        remiseId = resultAny.id;
                    }
                }
                
                if (!remiseId) {
                    this.toastr.error('Erreur: Impossible de récupérer l\'ID de la remise. Veuillez vérifier les logs.', 'Erreur');
                    this.isLoading = false;
                    return;
                }
                let tresorerieIdBackend: number | null = null;
                if (resultAny?.data?.remise_banque?.lignes && Array.isArray(resultAny.data.remise_banque.lignes) && resultAny.data.remise_banque.lignes.length > 0) {
                    tresorerieIdBackend = resultAny.data.remise_banque.lignes[0].tresorerie_id || null;
                    console.log('⚠️ [RemiseBanqueComponent] Opération créée par le backend (avec solde_type null):', tresorerieIdBackend);
                }
                const methodePaiement: 'espece' | 'cheque' | 'traite' = this.formData.type_remise as 'espece' | 'cheque' | 'traite';
                const operationTresorerieComplete: Tresorerie = {
                    date_operation: this.formData.date_banque || new Date().toISOString().split('T')[0],
                    type_operation: 'remise_banque',
                    type_paiement: 'credit',
                    montant: this.formData.montant_total.toString(),
                    montant_ttc: this.formData.montant_total.toString(),
                    methode_paiement: methodePaiement,
                    solde_type: this.soldeType,
                    remise_banque_id: remiseId,
                    numero_remise: this.formData.numero_remise,
                    date_banque: this.formData.date_banque,
                    banque_id: banqueId,
                    compte_bancaire_id: this.formData.compte_bancaire_id,
                    note: this.formData.note || null,
                    description: `Remise en banque - ${this.formData.type_remise} - N° ${this.formData.numero_remise}`,
                    user_id: this.userId,
                    station_id: this.stationId,
                    statut: 'valide',
                    document_id: null,
                    paiement_id: null,
                    categorie_id: null
                };
                const operationTresorerieUpdate: Partial<Tresorerie> = {
                    solde_type: this.soldeType,
                    banque_id: banqueId,
                    compte_bancaire_id: this.formData.compte_bancaire_id,
                    type_paiement: 'credit',
                    description: `Remise en banque - ${this.formData.type_remise} - N° ${this.formData.numero_remise}`,
                    note: this.formData.note || null,
                    statut: 'valide'
                };
                if (tresorerieIdBackend) {
                    console.log('🔄 [RemiseBanqueComponent] Mise à jour de l\'opération créée par le backend:', tresorerieIdBackend);
                    console.log('🔄 [RemiseBanqueComponent] Requête PUT (JSON):', JSON.stringify(operationTresorerieUpdate, null, 2));
                    this.tresorerieService.updateTresorerie(tresorerieIdBackend, operationTresorerieUpdate as Tresorerie).subscribe({
                        next: (tresorerieResult) => {
                            console.log('✅ [RemiseBanqueComponent] Opération mise à jour avec le bon solde_type et banque_id:', tresorerieResult);
                            console.log('⏳ [RemiseBanqueComponent] Attente du recalcul des soldes par le backend...');
                            this.toastr.success('Remise en banque créée avec succès.', 'Succès');
                            this.modalRef.close();
                            setTimeout(() => {
                                this.remiseCreated.emit();
                            }, 800);
                            this.isLoading = false;
                        },
                        error: (updateError) => {
                            console.error('❌ [RemiseBanqueComponent] Erreur lors de la mise à jour de l\'opération de trésorerie:', updateError);
                            this.toastr.error('Erreur lors de la mise à jour de l\'opération de trésorerie.', 'Erreur');
                            this.isLoading = false;
                        }
                    });
                } else {
                    console.log('➕ [RemiseBanqueComponent] Le backend n\'a pas créé d\'opération, création manuelle...');
                    console.log('➕ [RemiseBanqueComponent] Requête POST (JSON):', JSON.stringify(operationTresorerieComplete, null, 2));
                    this.tresorerieService.createTresorerie(operationTresorerieComplete).subscribe({
                        next: (tresorerieResult) => {
                            console.log('✅ [RemiseBanqueComponent] Opération créée avec le bon solde_type et banque_id:', tresorerieResult);
                            console.log('⏳ [RemiseBanqueComponent] Attente du recalcul des soldes par le backend...');
                            this.toastr.success('Remise en banque créée avec succès.', 'Succès');
                            this.modalRef.close();
                            setTimeout(() => {
                                this.remiseCreated.emit();
                            }, 800);
                            this.isLoading = false;
                        },
                        error: (createError) => {
                            console.error('❌ [RemiseBanqueComponent] Erreur lors de la création de l\'opération de trésorerie:', createError);
                            this.toastr.error('Erreur lors de la création de l\'opération de trésorerie.', 'Erreur');
                            this.isLoading = false;
                        }
                    });
                }
            },
            error: (error) => {
                if (error.error) {
                    console.error('❌ [RemiseBanqueComponent] Détails de l\'erreur:', error.error);
                }

                const isUniqueConstraintError = error.error?.details?.name === 'SequelizeUniqueConstraintError' ||
                                                error.error?.error === 'Validation error' ||
                                                (error.error?.message && error.error.message.includes('unique'));
                
                if (isUniqueConstraintError) {
                    this.cleanupOrphanedTresorerieOperation();
                    
                    this.toastr.error(
                        'Le numéro de remise existe déjà. Veuillez utiliser un numéro différent.',
                        'Erreur de validation'
                    );
                } else {
                    this.toastr.error('Erreur lors de l\'enregistrement de la remise.', 'Erreur');
                }
                
                this.isLoading = false;
            }
        });
    }
    private cleanupOrphanedTresorerieOperation(): void {
        console.log('🧹 [RemiseBanqueComponent] Recherche d\'opérations orphelines à nettoyer...');
        const filters = {
            station_id: this.stationId,
            type_operation: 'remise_banque',
            numero_remise: this.formData.numero_remise,
            date_banque: this.formData.date_banque
        };
        
        this.tresorerieService.getTresorerieList(filters).subscribe({
            next: (operations) => {
                const orphanedOperations = operations.filter(op => 
                    op.type_operation === 'remise_banque' &&
                    op.numero_remise === this.formData.numero_remise &&
                    (!op.remise_banque_id || op.remise_banque_id === null)
                );
                
                if (orphanedOperations.length > 0) {
                    console.log(`🗑️ [RemiseBanqueComponent] ${orphanedOperations.length} opération(s) orpheline(s) trouvée(s), suppression...`);
                    orphanedOperations.forEach(op => {
                        if (op.id) {
                            this.tresorerieService.deleteTresorerie(op.id).subscribe({
                                next: () => {
                                    console.log(`✅ [RemiseBanqueComponent] Opération orpheline ${op.id} supprimée`);
                                },
                                error: (deleteError) => {
                                    console.error(`❌ [RemiseBanqueComponent] Erreur lors de la suppression de l'opération orpheline ${op.id}:`, deleteError);
                                }
                            });
                        }
                    });
                } else {
                    console.log('✅ [RemiseBanqueComponent] Aucune opération orpheline trouvée');
                }
            },
            error: (searchError) => {
                console.error('❌ [RemiseBanqueComponent] Erreur lors de la recherche d\'opérations orphelines:', searchError);
            }
        });
    }

    private validateForm(): boolean {
        if (!this.formData.type_remise) {
            this.toastr.error('Le type de remise est requis.', 'Erreur');
            return false;
        }
        if (!this.formData.numero_remise) {
            this.toastr.error('Le numéro de remise est requis.', 'Erreur');
            return false;
        }
        if (!this.formData.date_banque) {
            this.toastr.error('La date de banque est requise.', 'Erreur');
            return false;
        }
        if (!this.formData.compte_bancaire_id) {
            this.toastr.error('Le compte bancaire est requis.', 'Erreur');
            return false;
        }
        if (!this.formData.montant_total || this.formData.montant_total <= 0) {
            this.toastr.error('Le montant est requis et doit être supérieur à 0.', 'Erreur');
            return false;
        }
        return true;
    }
    getTypeRemiseLabel(): string {
        switch (this.formData.type_remise) {
            case 'cheque': return 'Chèque';
            case 'traite': return 'Traite';
            case 'espece': return 'Espèce';
            default: return '';
        }
    }
    formatDate(dateString: string): string {
        if (!dateString) return '--';
        try {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (error) {
            return dateString;
        }
    }
}
